import React from 'react';
import Button from '../common/Button';

const CertificationsTab = ({
    certifications,
    addItem,
    editIndex,
    editItem,
    loading,
    onAddChange,
    onEditChange,
    onCancelAdd,
    onCancelEdit,
    onEdit,
    onAddCertification,
    onUpdateCertification,
    onDeleteCertification,
    setAddItem
}) => {
    return (
        <div>
            <div className="flex justify-between items-center mb-3">
                <h3 className="text-lg font-semibold text-gray-900">Certifications</h3>
                {addItem.certifications ? (
                    <div className="flex gap-2">
                        <input
                            type="text"
                            placeholder="Certification Name"
                            value={addItem.certifications.name || ''}
                            onChange={e => onAddChange('certifications', 'name', e.target.value)}
                            className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                        />
                        <input
                            type="text"
                            placeholder="Issuing Body"
                            value={addItem.certifications.issuingBody || ''}
                            onChange={e => onAddChange('certifications', 'issuingBody', e.target.value)}
                            className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                        />
                        <input
                            type="number"
                            placeholder="Year"
                            value={addItem.certifications.year || ''}
                            onChange={e => onAddChange('certifications', 'year', parseInt(e.target.value))}
                            className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                        />
                        <Button
                            type="button"
                            variant="primary"
                            onClick={onAddCertification}
                            loading={loading}
                        >
                            Add
                        </Button>
                        <Button
                            type="button"
                            variant="secondary"
                            onClick={() => onCancelAdd('certifications')}
                            loading={loading}
                        >
                            Cancel
                        </Button>
                    </div>
                ) : (
                    <Button
                        type="button"
                        variant="primary"
                        onClick={() => setAddItem({ ...addItem, certifications: { name: '', issuingBody: '', year: '' } })}
                    >
                        Add Certification
                    </Button>
                )}
            </div>
            {certifications.length === 0 && <div className="text-gray-500">No certifications added.</div>}
            {certifications.map((cert, idx) => (
                <div key={cert.id || idx} className="border border-gray-200 rounded-lg p-4 mb-3 flex items-center justify-between">
                    {editIndex.certifications === idx ? (
                        <div className="flex gap-2 flex-wrap w-full">
                            <input
                                type="text"
                                placeholder="Certification Name"
                                value={editItem.certifications.name || ''}
                                onChange={e => onEditChange('certifications', 'name', e.target.value)}
                                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                            />
                            <input
                                type="text"
                                placeholder="Issuing Body"
                                value={editItem.certifications.issuingBody || ''}
                                onChange={e => onEditChange('certifications', 'issuingBody', e.target.value)}
                                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                            />
                            <input
                                type="number"
                                placeholder="Year"
                                value={editItem.certifications.year || ''}
                                onChange={e => onEditChange('certifications', 'year', parseInt(e.target.value))}
                                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                            />
                            <Button
                                type="button"
                                variant="primary"
                                onClick={() => onUpdateCertification(idx)}
                                loading={loading}
                            >
                                Save
                            </Button>
                            <Button
                                type="button"
                                variant="secondary"
                                onClick={() => onCancelEdit('certifications')}
                                loading={loading}
                            >
                                Cancel
                            </Button>
                        </div>
                    ) : (
                        <>
                            <div className="flex-1 flex gap-4 items-center">
                                <span className="font-medium">{cert.name}</span>
                                <span className="text-gray-600">{cert.issuingBody}</span>
                                <span className="text-gray-500">{cert.year}</span>
                            </div>
                            <div className="flex gap-2">
                                <Button
                                    type="button"
                                    variant="secondary"
                                    onClick={() => onEdit('certifications', idx)}
                                    loading={loading}
                                >
                                    Edit
                                </Button>
                                <Button
                                    type="button"
                                    variant="danger"
                                    onClick={() => onDeleteCertification(idx)}
                                    loading={loading}
                                >
                                    Delete
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            ))}
        </div>
    );
};

export default CertificationsTab; 